














import {Component, Prop, Vue} from "vue-property-decorator";
import ChangeCreditInput from "@/components/change_credit/Input.vue";
import ChangeCreditResult from "@/components/change_credit/Result.vue";

import {mapGetters} from "vuex";

@Component({
    components: {
        ChangeCreditInput,
        ChangeCreditResult
    },
    computed:
        mapGetters({
            progress:'changeCredit/progress'
        }),
})
export default class ChangeCredit extends Vue {
    email: string | null = null;

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    beforeDestroy() {
        this.$store.dispatch('changeCredit/pushProgress', 'input');
    }
}
